import { combineReducers } from 'redux';

import { projects } from './project-reducer';
import { world } from './world-reducer';

export default combineReducers({
  projects, world,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/reducers/index.ts